<template lang="pug">
  v-btn(:color="buttonColor" :loading="loading" :block="block" :min-width="unsetMinWidth ? 'unset' : ''" :class="[sizeClass, buttonClass]" :disabled="disabled" :outlined="outlined" :style="buttonStyle" depressed :dark="disabled ? false : dark" @click="emitClick" :text="underline || text")
    .d-flex.align-center
      template(v-if="prependIcon")
        v-icon(:size="iconSize" :color="buttonIconColor") {{ prependIcon }}
        .mr-2(v-if="label")
      div(:class="labelClass") {{ label }}
      template(v-if="appendIcon")
        .ml-2(v-if="label")
        v-icon(:size="iconSize" :color="buttonIconColor") {{ appendIcon }}
    template(#loader)
      v-progress-circular(indeterminate :size="sizeLoader" :width="widthLoader")

    slot(name="content")

</template>

<script>
export default {
  name: 'YBtn',
  props: {
    label: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'primary'
    },
    textColor: {
      type: String,
      default: null
    },
    backgroundColor: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md'
      // sm, md, lg
    },
    height: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: null
    },
    appendIcon: {
      type: String,
      default: null
    },
    prependIcon: {
      type: String,
      default: null
    },
    iconSize: {
      default: 24
    },
    iconColor: {
      type: String,
      default: null
    },
    dark: {
      type: Boolean,
      default: false
    },
    underline: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: null
    },
    unsetMinWidth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sizeClass () {
      switch (this.size) {
        case 'xxs':
          return 'button-xxs'
        case 'xs':
          return 'button-xs'
        case 'sm':
          return 'button-sm'
        case 'md':
          return 'button-md'
        case 'lg':
          return 'button-lg'
        default:
          return 'button-lg'
      }
    },
    sizeLoader () {
      if (this.height) {
        return Number(this.height) - 12
      }
      switch (this.size) {
        case 'xxs':
          return 16
        case 'xs':
          return 20
        case 'sm':
          return 24
        case 'md':
          return 32
        case 'lg':
          return 44
        default:
          return 44
      }
    },
    widthLoader () {
      if (this.sizeLoader >= 30) {
        return 3
      }
      return 2
    },
    buttonColor () {
      let color = this.color
      if (this.underline) {
        color = 'transparent'
      }
      if (this.disabled) {
        color = 'primary'
      }
      return color
    },
    buttonIconColor () {
      let color = this.iconColor
      if (this.disabled) {
        color = 'neutral400'
      }
      return color
    },
    labelClass () {
      let cls = ''
      if (this.textColor) {
        cls = `${this.textColor}--text`
        if (this.disabled) {
          cls = null
        }
      }
      if (this.underline) {
        if (!cls) {
          cls = 'neutral700--text'
          if (this.disabled) {
            cls = 'neutral400--text'
          }
        }
        cls = `${cls} underline underline-offset`
      }
        
      return cls
    },
    buttonStyle () {
      let style = {}
      if (this.backgroundColor) {
        style.backgroundColor = this.backgroundColor
      }
      if (this.height) {
        style.height = `${this.height}px !important`
      }
      if (this.width) {
        style.width = `${this.width}px !important`
      }
      return style
    }
  },
  methods: {
    emitClick () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.underline-offset {
  text-underline-offset: 4px;
}
</style>